import { ethers as e } from "ethers";
import { ERC20ContractAbi as o } from "@deorderbook/contracts/abi";
import { sellTokenAddress as n } from "@deorderbook/contracts";
import { signer as c, provider as s } from "./provider.mjs";
const i = () => new e.Contract(
  n,
  o
), p = (t = !1) => {
  const r = i();
  return t ? r.connect(c) : r.connect(s);
};
export {
  i as initSellTokenContract,
  p as useSellTokenContract
};
//# sourceMappingURL=sellTokenContract.mjs.map
